import { getAreacode } from '@/api';
export default {
  props: {
    value: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      localValue: this.value,
      codes: []
    };
  },

  watch: {
    value(val) {
      this.localValue = val;
    },

    localValue(val) {
      this.$emit('input', val);
    }

  },

  async created() {
    this.codes = (await getAreacode()).map(i => {
      return {
        value: i.code,
        label: `+${i.code}`,
        country: i.country
      };
    });
  },

  methods: {
    getCountry() {
      return this.codes.find(i => i.value == this.localValue)?.country.toLowerCase();
    }

  }
};